import { useEffect } from 'react';
import './Modal.css';

export const Modal = ({ isOpen, onClose, title, children, className = '' }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className={`modal-panel u-scale-in ${className}`} onClick={(e) => e.stopPropagation()}>
        {title ? (
          <div className="modal-header">
            <h2 className="modal-title">{title}</h2>
            {onClose ? (
              <button className="modal-close" onClick={onClose}>
                ✕
              </button>
            ) : null}
          </div>
        ) : null}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
};
